class VwIstempaneltanimDTO {
    testAdi?: string;
    id?: number;
    fkGnlOrganizasyonId?: number;
    fkIstempaneltanimId?: number;
    aciklama?: string;
    sira?: number;
    tip?: number;
    aktif?: string;
    fkHbsTesttanimId?: number;
    rutinaktiftest?: string;
    paneltip?: number;
    panelacik?: string;
    pacsDirekGonder?: string;
    ekleyenKullanici?: number;
    eklemeTarih?: string;
    guncelleyenKullanici?: number;
    guncellemeTarihi?: string;
    islemId?: number;
    islemAdi?: string;
    islemKodu?: string;
    skKullanici?: number;
    skKullaniciAdsoyad?: string;
    kdvoran?: number;
    islemtipId?: number;
    treekey?: string;
}
export default VwIstempaneltanimDTO;